import React from 'react';
import {
    Button,
    ButtonVariants,
    ButtonColors,
    ButtonFontWeights,
    Text,
    TextAs,
    TextSizes,
} from '@clockout-dev/design-elements';
import { ReconciliationOutlined } from '@ant-design/icons';
import SectionCard from '../../../common/sectionCard/SectionCard';
import styles from './styles/reconcile-account-card.module.scss';

/**
 * "Reconcile Account" card. The button only opens the confirmation
 * modal — the page owns the request, so this stays presentational
 * like the other cards in the rail.
 *
 * The whole card is hidden unless the admin holds
 * SCOPES.USERS_RECONCILE (gated in user.js), so it renders its
 * action unconditionally.
 *
 * No amounts are shown: `consumer.advanceAmount` / `feesAmount` are
 * lifetime totals (see UserKpiCards), not what the member currently
 * owes, and showing a lifetime figure next to a settle button would
 * read as the amount about to be settled.
 * TODO(backend): surface outstanding advances/fees on the consumer
 * payload and render them here as UserCardRow rows.
 *
 * @param {Object} props
 * @param {() => void} props.onReconcile Opens the confirmation modal.
 * @param {boolean} [props.loading] True while the request is in flight.
 */
function ReconcileAccountCard({ onReconcile, loading }) {
    return (
        <SectionCard icon={<ReconciliationOutlined />} title="Reconcile Account">
            <Text as={TextAs.P} size={TextSizes.SMALL} className={styles.description}>
                Settle all of this user&apos;s outstanding debt — advances and fees — with a
                single ledger adjustment against their latest pay period. No real funds are
                moved, and this cannot be undone.
            </Text>

            <div className={styles.footer}>
                <Button
                    variant={ButtonVariants.DEFAULT}
                    color={ButtonColors.LIGHT}
                    fontWeight={ButtonFontWeights.BOLD}
                    onClick={onReconcile}
                    disabled={!!loading}
                    className={`${styles.footerBtn} ${styles.footerBtnDanger}`}
                >
                    Reconcile Account
                </Button>
            </div>
        </SectionCard>
    );
}

export default ReconcileAccountCard;
